<template>
  <div>
    <!-- <GoogleAccountOnboarding v-if="isGoogleNotConnected" /> -->
    <div
      class="Polaris-ShadowBevel"
      style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
    >
      <div
        class="Polaris-Box"
        style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400);"
      >
        <div class="Polaris-SettingAction">
          <div class="Polaris-SettingAction__Setting">
            <div
              class="Polaris-InlineStack"
              style="--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-100)"
                v-if="isGoogleNotConnected"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingSm flex">
                  <img src="../../assets/google.svg" class="w-5 h-5" />
                  <span class="px-2">Add your Google Businesses </span>
                </h2>
              </div>
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-100)"
                v-if="googleAccount.accountName"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingSm flex">
                  <img src="../../assets/google.svg" class="w-5 h-5" />
                  <span class="px-2"
                    >You have connected {{ googleAccount.accountName }} account
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div
            class="Polaris-SettingAction__Action"
            v-if="isGoogleNotConnected"
          >
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="connectGoogle"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Connect</span
              >
            </button>
          </div>
          <div
            class="Polaris-SettingAction__Action"
            v-if="googleAccount.isGoogleConnected"
          >
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="openLocationModal"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Manage Account</span
              >
            </button>
          </div>
        </div>
        <div
          class="Polaris-Box"
          style="--pc-box-padding-block-start-xs: var(--p-space-400);"
          v-if="googleAccount.accountName"
        >
          <div class="bg-white px-1 py-5">
            <div
              class="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap"
            >
              <div class="ml-4 mt-4">
                <div class="flex items-center">
                  <div class="flex-shrink-0">
                    <img
                      class="h-16 w-16 rounded-full"
                      src="../../assets/google.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-4">
                    <h3 class="text-base font-semibold leading-6 text-gray-900">
                      {{ googleAccount.locationName }}
                    </h3>
                    <p
                      class="text-sm text-gray-500 flex items-center"
                      v-if="googleAccount.averageRating"
                    >
                      <svg
                        class="h-5 w-5 flex-shrink-0 text-yellow-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        data-slot="icon"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span class="px-2"
                        >{{ googleAccount.averageRating.toFixed(1) }} ({{
                          googleAccount.totalReviewCount
                        }})</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="ml-4 mt-4 flex flex-shrink-0">
                <button
                  type="button"
                  class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  @click="showRemovePrompt"
                >
                  <span>Remove</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="Polaris-Box"
          style="--pc-box-padding-block-start-xs: var(--p-space-400);"
          v-if="isGoogleNotConnected"
        >
          <span class="Polaris-Text--root Polaris-Text--bodyMd">
            <p>
              Once you connected your google accounts, Your reviews will be
              synced to our app
            </p>
          </span>
        </div>
      </div>
    </div>
    <LocationSelectorModal
      v-if="showLocationSelection"
      :googleAccount="googleAccount"
      @close="closeLocationModal"
      @selected="onLocationSelected"
    ></LocationSelectorModal>
    <AlertModal
      v-if="showAlert"
      @close="closeAlertModal"
      @onDelete="onGoogleAccountDeleted"
    ></AlertModal>
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";

import LocationSelectorModal from "./LocationSelectorModal.vue";
// import GoogleAccountOnboarding from "./GoogleAccountOnboarding.vue";
import AlertModal from "./AlertModal.vue";

export default {
  components: {
    LocationSelectorModal,
    // GoogleAccountOnboarding,
    // Spinner,
    AlertModal
  },
  data() {
    return {
      isLoading: true,
      googleAccount: {},
      isGoogleNotConnected: false,
      showLocationSelection: false,
      showAlert: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getGoogleConfig").then(response => {
        this.isLoading = false;
        this.$store.commit("SET_GOOGLE_ACCOUNT", response.googleAccount);
        if (response.googleAccount.isGoogleConnected === false) {
          this.isGoogleNotConnected = true;
        }

        this.googleAccount = response.googleAccount;
        if (
          this.googleAccount &&
          this.googleAccount.isGoogleConnected &&
          (this.googleAccount.locationId === null ||
            typeof this.googleAccount.locationId == "undefined")
        ) {
          this.openLocationModal();
        }
      });
    },
    connectGoogle() {
      this.$store.dispatch("connectGoogle").then(response => {
        if (response.url) {
          console.log("connect to google", response.url);
          open(response.url, "_top");
        }
      });
    },
    openLocationModal() {
      this.showLocationSelection = true;
    },
    closeLocationModal() {
      this.showLocationSelection = false;
    },
    showRemovePrompt() {
      this.showAlert = true;
    },
    onLocationSelected({ locationId, locationName, newReviewUri }) {
      this.$store
        .dispatch("updateGoogleLocation", {
          requestParams: { locationId, locationName, newReviewUri }
        })
        .then(() => {
          this.init();
          this.$store.dispatch("showNotification", {
            text: "Updated Account"
          });
        });
    },
    onGoogleAccountDeleted() {
      this.init();
      this.closeAlertModal();
    },
    closeAlertModal() {
      this.showAlert = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
